import { EnvVariables } from './helpers/EnvVariables.js';
import { defineInjectable } from './Injectable.js';
const DEPS = {
    env: EnvVariables,
};
/** Implementation overload for defineEnvVariable. */
export function defineEnvVariable(name, options) {
    const defaultValue = options?.default;
    return defineInjectable({
        name,
        deps: DEPS,
        required: options?.required ?? !defaultValue,
        parse: options?.parse,
        resolve,
        default: defaultValue ? (typeof defaultValue === 'function' ? defaultValue : () => defaultValue) : undefined,
        get: getValue,
        assert: assertValue,
    });
}
function getValue() {
    const value = process.env[this.name];
    if (value == null) {
        return this.default?.();
    }
    if (this.parse) {
        return this.parse(value);
    }
    return value;
}
function assertValue() {
    const value = getValue.call(this);
    if (value == null) {
        throw new Error(`Environment variable ${this.name} is not set.`);
    }
    return value;
}
function resolve(container, caller) {
    const name = this.name;
    const env = container.resolve(EnvVariables);
    const value = env[name];
    if (!value) {
        if (this.default) {
            return this.default();
        }
        if (this.required) {
            throw new Error(`Environment variable ${name} is not set. Caller: ${caller?.name}`);
        }
    }
    if (this.parse) {
        return this.parse(value);
    }
    return value;
}
//# sourceMappingURL=defineEnvVariable.js.map